// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import TopBanner from "./components/TopBanner";
import HeroKycIntro from "./components/HeroKycIntro";
import InfoCards from "./components/InfoCards";
import Disclaimer from "./components/Disclaimer";
import KycForm from "./components/KycForm";
import Confirmation from "./components/Confirmation";
import Login from "./components/Login";
import VideoLogin from "./components/VideoLogin";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";

const isVideoAuthenticated = () => {
  try {
    return sessionStorage.getItem("isAuthenticated") === "true";
  } catch {
    return false;
  }
};

const RequireVideoAuth = ({ children }) =>
  isVideoAuthenticated() ? children : <Navigate to="/video-login" replace />;

const AppContent = () => {
  const location = useLocation();
  const hideBanner = ["/login", "/dashboard"].includes(location.pathname);

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/MainBody04.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {!hideBanner && <TopBanner />}

      <Routes>
        <Route path="/" element={<Navigate to="/video-login" replace />} />

        <Route
          path="/home"
          element={
            <RequireVideoAuth>
              <>
                <HeroKycIntro />
                <InfoCards />
              </>
            </RequireVideoAuth>
          }
        />

        <Route path="/disclaimer" element={<Disclaimer />} />

        <Route
          path="/kyc-form"
          element={
            <RequireVideoAuth>
              <KycForm />
            </RequireVideoAuth>
          }
        />

        <Route path="/video-login" element={<VideoLogin />} />
        <Route path="/login" element={<Login />} />

        <Route
          path="/confirmation"
          element={
            <RequireVideoAuth>
              <Confirmation />
            </RequireVideoAuth>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/video-login" replace />} />
      </Routes>
    </div>
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
